import { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import Filters from './Filters';
import Hits from './Hits';
import ShowMore from './ShowMore';

const VehicleSearch = (props) => {
    const showFilters = props.show_filters ?? true;
    let perPage = props.per_page ?? 0;

    if(window.screen.width < 900 && props.per_page_tablet) {
        perPage = props.per_page_tablet;
    }
    if(window.screen.width < 600 && props.per_page_mobile) {
        perPage = props.per_page_mobile;
    }

    const parseFilter = (text, isArray = false) => {
        if (isArray) {
            return text.split(',').map((text) => {
                return text.trim();
            });
        }
        return text ? text.trim() : '';
    }

    const defaultFilters = () => {
        return {
            sort: 'date',
            type: [],
            brand: [],
            model: [],
            facility: [],
            fuel_type: [],
            is_new: '',
            gearbox_type: [],
            color_group: [],
            body_type: [],
            towbar: '',
            four_wheel_drive: '',
            price_leasing: '',
            price_changed: '',
            price_vat: '',
            model_year_min: '',
            model_year_max: '',
            miles_min: '',
            miles_max: '',
            price_min: '',
            price_max: '',
            auction: 0,
            city: '',
        };
    }

    const updateFiltersFromProps = (filters) => {
        if(props.ids) {
            filters.ids = parseFilter(props.ids, true);
        }
        if (props.sort) {
            filters.sort = parseFilter(props.sort);
        }
        if (props.type) {
            filters.type = parseFilter(props.type, true);
        }
        if (props.brand) {
            filters.brand = parseFilter(props.brand, true);
        }
        if (props.model) {
            filters.model = parseFilter(props.model, true);
        }
        if (props.facility) {
            filters.facility = parseFilter(props.facility, true);
        }
        if (props.fuel_type) {
            filters.fuel_type = parseFilter(props.fuel_type, true);
        }
        if (props.is_new) {
            filters.is_new = parseFilter(props.is_new);
        }
        if (props.gearbox_type) {
            filters.gearbox_type = parseFilter(props.gearbox_type, true);
        }
        if (props.color_group) {
            filters.color_group = parseFilter(props.color_group, true);
        }
        if (props.body_type) {
            filters.body_type = parseFilter(props.body_type, true);
        }
        if (props.towbar) {
            filters.towbar = parseFilter(props.towbar);
        }
        if (props.four_wheel_drive) {
            filters.four_wheel_drive = parseFilter(props.four_wheel_drive);
        }
        if (props.price_leasing) {
            filters.price_leasing = parseFilter(props.price_leasing);
        }
        if (props.price_changed) {
            filters.price_changed = parseFilter(props.price_changed);
        }
        if (props.price_vat) {
            filters.price_vat = parseFilter(props.price_vat);
        }
        if (props.model_year_min) {
            filters.model_year_min = parseFilter(props.model_year_min);
        }
        if (props.model_year_max) {
            filters.model_year_max = parseFilter(props.model_year_max);
        }
        if (props.miles_min) {
            filters.miles_min = parseFilter(props.miles_min);
        }
        if (props.miles_max) {
            filters.miles_max = parseFilter(props.miles_max);
        }
        if (props.price_min) {
            filters.price_min = parseFilter(props.price_min);
        }
        if (props.price_max) {
            filters.price_max = parseFilter(props.price_max);
        }
        if (props.city) {
            filters.city = parseFilter(props.city);
        }

        filters.auction = parseFilter(props.auction);

        return filters;
    }

    const updateFiltersFromURL = (filters) => {
        const params = new URLSearchParams(location.search);

        if (params.has('sort')) {
            filters.sort = parseFilter(params.get('sort'));
        }
        if (params.has('type')) {
            filters.type = parseFilter(params.get('type'), true);
        }
        if (params.has('brand')) {
            filters.brand = parseFilter(params.get('brand'), true);
        }
        if (params.has('model')) {
            filters.model = parseFilter(params.get('model'), true);
        }
        if (params.has('facility')) {
            filters.facility = parseFilter(params.get('facility'), true);
        }
        if (params.has('fuel_type')) {
            filters.fuel_type = parseFilter(params.get('fuel_type'), true);
        }
        if (params.has('is_new')) {
            filters.is_new = parseFilter(params.get('is_new'));
        }
        if (params.has('gearbox_type')) {
            filters.gearbox_type = parseFilter(params.get('gearbox_type'), true);
        }
        if (params.has('color_group')) {
            filters.color_group = parseFilter(params.get('color_group'), true);
        }
        if (params.has('body_type')) {
            filters.body_type = parseFilter(params.get('body_type'), true);
        }
        if (params.has('towbar')) {
            filters.towbar = parseFilter(params.get('towbar'));
        }
        if (params.has('four_wheel_drive')) {
            filters.four_wheel_drive = parseFilter(params.get('four_wheel_drive'));
        }
        if (params.has('price_leasing')) {
            filters.price_leasing = parseFilter(params.get('price_leasing'));
        }
        if (params.has('price_changed')) {
            filters.price_changed = parseFilter(params.get('price_changed'));
        }
        if (params.has('price_vat')) {
            filters.price_vat = parseFilter(params.get('price_vat'));
        }
        if (params.has('model_year_min')) {
            filters.model_year_min = parseFilter(params.get('model_year_min'));
        }
        if (params.has('model_year_max')) {
            filters.model_year_max = parseFilter(params.get('model_year_max'));
        }
        if (params.has('miles_min')) {
            filters.miles_min = parseFilter(params.get('miles_min'));
        }
        if (params.has('miles_max')) {
            filters.miles_max = parseFilter(params.get('miles_max'));
        }
        if (params.has('price_min')) {
            filters.price_min = parseFilter(params.get('price_min'));
        }
        if (params.has('price_max')) {
            filters.price_max = parseFilter(params.get('price_max'));
        }
        if (params.has('city')) {
            filters.city = parseFilter(params.get('city'));
        }

        return filters;
    }

    const [isLoading, setIsLoading] = useState(false);
    const [hits, setHits] = useState([]);

    const [filters, setFilters] = useState(() => {
        let filters = defaultFilters();
        filters = updateFiltersFromProps(filters);
        filters = updateFiltersFromURL(filters);
        return filters;
    });
    const [facets, setFacets] = useState({});
    const [search, setSearch] = useState(() => {
        const params = new URLSearchParams(location.search);
        if (params.has('search')) {
            return params.get('search');
        }
        return props.search ?? ''
    });
    const [debouncedSearch] = useDebounce(search, 500);

    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search);
        if (params.has('page')) {
            return parseInt(params.get('page'));
        }
        return 1;
    });
    const [totalPages, setTotalPages] = useState(1);

    const reset = () => {
        let filters = defaultFilters();
        filters = updateFiltersFromProps(filters);
        setFilters(filters);
        // TODO: fix debounce
        setSearch(props.search ?? '');
        setCurrentPage(1);
    }

    const updateURL = (filters) => {
        const url = new URL(window.document.URL);

        if (showFilters) {
            for (let [key, value] of Object.entries(filters)) {
                if (value.length > 0) {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            }

            if (url.searchParams.get('sort') === 'date') {
                url.searchParams.delete('sort');
            }

            if (debouncedSearch !== '') {
                url.searchParams.set('search', debouncedSearch);
            } else {
                url.searchParams.delete('search');
            }
        }

        if (currentPage > 1) {
            url.searchParams.set('page', currentPage);
        } else {
            url.searchParams.delete('page');
        }

        window.history.replaceState(null, '', url.toString());
    }

    const sortFacets = (facets) => {
        for (let [name, values] of Object.entries(facets)) {
            // sort by label first
            values = values.sort((a, b) => {
                return a.label.localeCompare(b.label, 'sv');
            });

            if (name === 'facility' || name === 'model' || name === 'city') {
                // non-zero first
                values = values.sort((a, b) => {
                    if (parseInt(a.count) === 0) {
                        return 1;
                    }
                    if (parseInt(b.count) === 0) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                // sort by count
                values = values.sort((a, b) => {
                    if (parseInt(a.count) < parseInt(b.count)) {
                        return 1;
                    }
                    if (parseInt(a.count) > parseInt(b.count)) {
                        return -1;
                    }
                    return 0;
                });
            }

            facets[name] = values.map((item) => {
                return {
                    label: `${item.label} (${item.count})`,
                    value: item.value,
                    count: item.count,
                };
            });
        }

        return facets;
    }

    useEffect(() => {
        updateURL(filters);

        let url = horizon.ajaxUrl + '?action=nobox_vehicles_search';

        for (let [key, value] of Object.entries(filters)) {
            if (value.length > 0) {
                url += `&${key}=${value}`;
            }
        }

        if (debouncedSearch !== '') {
            url += '&search=' + debouncedSearch;
        }

        if (perPage > 0) {
            url += '&per_page=' + perPage;
        }

        if (currentPage > 1) {
            url += '&page=' + currentPage;
        }

        setIsLoading(true);

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setFacets(sortFacets(data.facets));

                setHits(data.hits);

                setTotalPages(Math.ceil(data.total / data.per_page));

                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [filters, debouncedSearch, currentPage]);

    return (
        <div className="vehiclesearch">
            {showFilters && (
                <Filters facets={facets} filters={filters} setFilters={setFilters} search={search} setSearch={setSearch} setCurrentPage={setCurrentPage} reset={reset} />
            )}
            {isLoading && (
                <div className="loading">
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
            )}
            <Hits hits={hits} isLoading={isLoading} />
            <ShowMore currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} isLoading={isLoading} />
        </div>
    );
}

export default VehicleSearch;
